module.exports = "/_next/static/images/slide19-e3361eb63608743c0a68891a0af95e1c.webp";